import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import { getStockAttributes } from "services/data.inventory.service";

const columns = [
  { label: "Zone ID", id: "zoneID" },
  { label: "Location ID", id: "locationID" },
  { label: "SKU Code", id: "skuCode" },
  { label: "Pallet Nbr", id: "palletNbr" },
  { label: "MLN", id: "mln" },
  { label: "New MLN", id: "newMLN" },
  { label: "Expiry Date", id: "expiryDate" },
  { label: "New Expiry Date", id: "newExpiryDate" },
  { label: "Remark", id: "remark" },
];

function StockAttributesDrawer({ open, setOpen, sAttributesRequest, setSAttributesRequest }) {

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["stock-attributes-log", { sAttributesRequest }],
    queryFn: () => getStockAttributes(sAttributesRequest),
    enabled: sAttributesRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;
      const details = item.stockAttributesDetails.map(x => {
        var rem = '';
        if (x.removeMLN) rem = rem + "Removed MLN.";

        if (x.removeExpiryDate) rem = rem + "Removed Expiry Date."

        x.remark = rem;

        return x;
      })
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Stock Attributes Number : </b>
                {item.stockAttributesNo}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
              <Grid item xs={6}>
                <b>Reason : </b>
                {item.reasonCode}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={details} />
          </div>
        </>
      );
    },
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setSAttributesRequest(null);
  };

  return (
    <Drawer width="1100px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default StockAttributesDrawer;
